// ThemeContext.tsx
"use client";
import { createContext, useContext, useEffect, useState } from "react";
 
type ThemeContextType = {
  isDark: boolean;
  toggle: () => void;
};
 
const ThemeContext = createContext<ThemeContextType | null>(null);
 
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [isDark, setIsDark] = useState(false);
 
  useEffect(() => {
    const stored = localStorage.getItem("theme");
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    const useDark = stored === "dark" || (!stored && prefersDark);
 
    document.documentElement.classList.toggle("dark", useDark);
    setIsDark(useDark);
  }, []);
 
  const toggle = () => {
    const newDark = !isDark;
    setIsDark(newDark);
    document.documentElement.classList.toggle("dark", newDark);
    localStorage.setItem("theme", newDark ? "dark" : "light");
  };
 
  return (
<ThemeContext.Provider value={{ isDark, toggle }}>
      {children}
</ThemeContext.Provider>
  );
}
 
export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme debe usarse dentro de <ThemeProvider>");
  return ctx;
}